<template>
  <div>
    <div class="WorkM_ApprovalConditionArea px-0 py-2 d-flex">
    </div>
    <!-- 一覧 -->
    <div class="WorkM_ApprovalApplicationListArea">
      <div v-if="!listEmptyCheck(approvalList)" class="mt-3">
        <div class="WorkM_ApprovalApplicationItem" v-for="approvalItem in approvalList" :key="approvalItem.slipNo" @click="clickApplication(approvalItem)">
          <!--リスト左側-->
          <div class="WorkM_OwnApplicationItem_HeaderArea">
            <div 
            class="SegmentLabel"
            :class="[
              { WorkInfoItem_WorkTimeArea_Red: !isAttendanceCheck(approvalItem.applicationKbn)},
            ]"
            style="font-size: 0.9rem; min-width:5rem"
            >
              {{ getDispSegment(approvalItem.applicationKbn) }}
            </div>
            <div style="margin-top: 6px; margin-bottom: 6px; font-size: 1rem;">
              <div v-if="approvalItem.approvalKbn == 1" class="ApprovalLabel">
                <div class="WorkContent_ItemTypeArea_TypeLabel text-center ApprovalIcon_Label mx-auto px-0">承認</div>
              </div>
              <div v-else-if="approvalItem.approvalKbn == 9" class="RejectionLabel">
                <div class="WorkContent_ItemTypeArea_TypeLabel text-center RejectionIcon_Label mx-auto px-0">否認</div>
              </div>
              <div v-else-if="approvalItem.approvalKbn == 0" class="RejectionLabel">
                <div class="WorkContent_ItemTypeArea_TypeLabel text-center PendingIcon_Label px-0">承認待ち</div>
              </div>
            </div>
          </div>
          <div class="WorkM_ApprovalApplicationItem_DetailArea" @click="openApplicationEditModal(approvalItem)" style="cursor: pointer;">
            <div style="margin-bottom:5px">
              <div class="ApprovalDetailItem">
                <div class="ApprovalDate" style="height: 25px;">
                  <div v-if="!emptyCheck(approvalItem.shainName)" class="mr-3 d-flex align-items-center" style="white-space: nowrap;">{{ "" + approvalItem.shainName + ""}}</div>
                </div>
                <div class="ApprovalDetailItem ApprovalDetailItemApprovalApplication">
                  <div v-if="!emptyCheck(approvalItem.departmentName) && !emptyCheck(approvalItem.sectionName)" class="mr-2 d-flex align-items-center ApprovalDetailItemConstruction">
                    {{ "" + approvalItem.departmentName + " " + approvalItem.sectionName + ""}}
                  </div>
                </div>
              </div>
              <div class="ApprovalDate ApprovalDateApprovalApplication">
                <div 
                v-if="!emptyCheck(approvalItem.applicationTargetDate)" 
                class="mr-2 d-flex align-items-center"
                style="min-width:110px;"
                >
                  {{ "" + approvalItem.applicationTargetDate + "" }}
                </div>
                <div 
                v-if="!emptyCheck(approvalItem.applicationTargetStartTime) && !emptyCheck(approvalItem.applicationTargetEndTime)" 
                class="d-flex align-items-center" 
                style="min-width:125px;">
                  {{ approvalItem.applicationTargetStartTime + "～" + approvalItem.applicationTargetEndTime }}
                </div>
              </div>
            </div>
            <!---->
            <div class="ApprovalDetailItem mt-1">
              <div>
                <div class="d-flex">
                  <div v-if="approvalItem.constructionCode > 0" class="mr-2">{{ "[" + approvalItem.constructionCode + "]" }}</div>
                  <div v-if="approvalItem.disasterKbn > 0" class="text-danger">災害</div>
                </div>
                <div v-if="!emptyCheck(approvalItem.constructionName)">{{ approvalItem.constructionName }}</div>
              </div>
            </div>
            <div class="ApprovalDetailItem">
              <div v-if="!emptyCheck(approvalItem.applicationReason)">
                <div class="DispReasonArea" v-html="setLineFeedCode(approvalItem.applicationReason)"></div>
              </div>
            </div>
            <div class="ApprovalDetailItem border-top border-dark mt-2" v-if="!emptyCheck(approvalItem.approvalDate)">
              <div v-if="approvalItem.approvalKbn == 1" class="DetailItem_TitleLabel">
                承認：
              </div>
              <div v-else-if="approvalItem.approvalKbn == 9" class="DetailItem_TitleLabel">
                否認：
              </div>
              <div v-if="!emptyCheck(approvalItem.approvalDate)">
                {{ approvalItem.approvalDate }}
              </div>
              <div class="ml-2" v-if="!emptyCheck(approvalItem.approvalShainName)">
                {{ "(" + approvalItem.approvalShainName + ")" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="mt-3 mb-1 border rounded-sm explainArea">
        <div>
          <label class="mb-0">表示対象の事前申請はありません。</label>
        </div>
      </div>
    </div>
    <!---->
    <div class="d-flex justify-content-between fixed-bottom px-1 ApprovalFooter" style="height:40px">
      <div class="d-flex align-items-center" style="min-width: 112px;">（ 全 {{ approvalList.length > 0? approvalList.length:0 }} 件 ）</div>
      <div class="d-flex align-items-center">
        <div class="mx-1" style="text-align: right; white-space: nowrap;">待ち {{countNonApproval}}件</div>
        <div class="mx-1" style="text-align: right; white-space: nowrap;">承認 {{countApproval}}件</div>
        <div class="mx-1" style="text-align: right; white-space: nowrap;">否認 {{countRejection}}件</div>
      </div>
    </div>
    <ApplicationEditModal 
    ref="ApplicationEditModal"
    :clickType="2"
    :selectApplication="this.selectApplication"
    ></ApplicationEditModal>
  </div>
</template>
<script>
import config from "../../const/config"
import ApplicationEditModal from "../Modal/ApplicationEditModal.vue";
export default {
  name: "ApprovalApplication",
  components: { ApplicationEditModal },
  props: {
    isApprovalHistory: { type: Boolean, default: true },
  },
  data() {
    return {
      selectApplication: {},
      approvalList:[
      ],
      countApproval: 0,
      countRejection: 0,
      countNonApproval: 0,
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
  },

  methods: {
    // 申請詳細情報取得イベント
    openApplicationEditModal: function (approvalItem) {
      console.debug("approvalItem：" + JSON.stringify(approvalItem));
      this.getApprovalApplicationInfoDetailAPI(approvalItem);
    },
    // APIから申請詳細情報の取得
    getApprovalApplicationInfoDetailAPI: function(approvalItem){
      let paramList = {
          shainCd: approvalItem.shainCd,
          targetDate: approvalItem.applicationTargetDate,
          applicationKbn: approvalItem.approvalKbn,
          applicationDenno: approvalItem.slipNo,
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.APPLICATION_REGIST+"/slipno", paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.isErrorGetShfitFlg = false;
            this.setApplicationRegistInfo(response.container);
            console.log("selectApplication：" + JSON.stringify(this.selectApplication));
            this.$refs.ApplicationEditModal.openModal();
          }
          else{
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },

    
    setApplicationRegistInfo: function(items){
      this.clickType = 2;
      this.selectApplication = {
        shiftStart: items.shiftStart, // シフト開始時刻
        shiftEnd: items.shiftEnd, // シフト終了時刻
        targetDateInfo: items.targetDateInfo,
        applicationInfoList: items.applicationInfoList[0],
        applicationRemainInfo: items.applicationRemainInfo,
      };
    },

    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.APPLICATION_SEGMENT_SIMPLE;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      this.applicationCount();
      return result;
    },
    // 申請承認情報を取得する
    getApprovalApplicationInfo: function(){
      console.log("call getApprovalApplicationInfo");
      this.getApprovalApplicationInfoAPI();
    },
    // APIから申請承認情報を取得する
    getApprovalApplicationInfoAPI: function(){
      let paramList = {
          shainCd: this.loginUserId,
          applicationKbn: 1,
      };
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.APPROVAL_REGIST_APPLICATION, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setApprovalApplicationInfo(response.container);
          }
          else{
            this.showAlertErrorHTML(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {
          this.applicationCount();
        });
    },
    // APIから申請承認情報を取得する
    getMyApprovalApplicationInfo: function(){
      let paramList = {
          shainCd: this.loginUserId,
          applicationKbn: 2,
      };
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.APPROVAL_REGIST_APPLICATION, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setApprovalApplicationInfo(response.container);
          }
          else{
            this.showAlertErrorHTML(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {
          this.applicationCount();
        });
    },
    // 取得した情報を変数にセットする
    setApprovalApplicationInfo: function(item){
      this.approvalList = item.applicationInfoList;
    },
    // 承認・否認件数チェック
    applicationCount: function(){
      console.log("call applicationCount");
      let countApproval = this.approvalList.filter((value) => {
        return value.approvalKbn == 1;
      });
      let countRejection = this.approvalList.filter((value) => {
        return value.approvalKbn == 9;
      });
      let countNonApproval = this.approvalList.filter((value) => {
        return value.approvalKbn == 0;
      });
      this.countApproval = countApproval.length;
      this.countRejection = countRejection.length;
      this.countNonApproval = countNonApproval.length;
    },
    // 出勤しているかチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function(workSegment){
      const WORK_SEGMENT_EARLY_START = 1; // 早出
      const WORK_SEGMENT_OVERTIME = 2; // 残業
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）
      
      if(workSegment != WORK_SEGMENT_EARLY_START
      && workSegment != WORK_SEGMENT_OVERTIME 
      && workSegment != WORK_SEGMENT_HOLIDAY_TRANSFER 
      && workSegment != WORK_SEGMENT_HOLIDAY_ALLOWANCE 
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER 
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE 
      && workSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },

    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    },
    // リストからチェック
    // true：空
    // false：空ではない
    listEmptyCheck: function(list){
      if(list != null && list.length > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 事由 改行コードを<br>にする
    setLineFeedCode: function(msg){
      let newMsg = msg?.replace(/\n/g,'<br>');
      return newMsg;
    },
    // 要素を選択すると申請画面に遷移する
    clickApplication: function(approvalItem){
      // 親コンポーネントが承認履歴の時、画面遷移しない
      if(this.$props.isApprovalHistory){
        return;
      }
      console.debug("approvalItem: " + JSON.stringify(approvalItem));
      // 「yyyy/mm/dd」から「yyyymmdd」に変換
      let targetDate = approvalItem.applicationTargetDate.replace(/\//g,'');
      console.debug("targetDate: " + targetDate);
      let targetDateInfo = {
        target_date: targetDate,
        is_from_work_calendar: true,
      };
      this.$store.commit("setTargetDateInfo", targetDateInfo);
      // pathに「/manager」とあったらPC側の申請画面へ遷移する
      let routerApplicationRegist = "";
      if(this.$route.path.indexOf('/manager') >= 0){
        routerApplicationRegist = config.PAGES.MANAGER_APPLICATION_REGIST;
      } 
      else {
        routerApplicationRegist = config.PAGES.APPLICATION_REGIST;
      }
      this.$router.push(routerApplicationRegist);
      
    },
  },
};
</script>
<style>
.ApprovalDetailItemApprovalApplication{
  font-weight: 400; 
  flex-wrap:wrap; 
  font-size:0.85rem;
}
.WorkM_ApprovalConditionArea {
  border-bottom: 1px solid rgb(212, 212, 212);
}

.WorkM_ApplicationHeader {
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-size: 1.2rem;
}
.ConditionStartDate {
  width: 280px;
}

.WorkM_ApprovalApplicationListArea {
  height: 100%;
}

.WorkM_ApprovalApplicationItem {
  display: flex;
  margin-bottom: 0.7rem;
  background: rgb(227, 227, 227);
  box-shadow: 2px 2px 3px rgb(230, 230, 230);
  border-radius: 5px;
  height: 100%;
}
.WorkM_ApprovalApplicationItem_HeaderArea {
  font-size: 0.9rem;
  height: 100%;
  min-width: 5rem;
}
.SegmentLabel {
  padding: 4px;
  width: 100%;
  background: rgb(24, 103, 194);
  color: rgb(255, 255, 255);
  font-weight: 700;
  border-radius: 5px 0 0 0;
  min-width: 4rem;
  text-align: center;
}

.ApprovalApplicationSelectArea {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ApprovalApplicationSelectArea .ApprovalLabel {
  padding-left: 0.5rem;
  text-align: left;
}
.ApprovalApplicationSelectArea .RejectionLabel {
  padding-left: 0.5rem;
  text-align: left;
}

.WorkM_ApprovalApplicationItem_DetailArea {
  overflow:hidden;
  padding: 0.3rem 0.5rem;
  flex-grow: 1;
  background: #f5f5f5;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDetailItem {
  display: flex;
  font-size: 0.95rem;
  flex-wrap: wrap;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDetailItem .DispReasonArea {
  word-break: break-all;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDate {
  font-size: 1.1rem;
  display: flex;
  font-weight: 700;
}
.ApprovalCheckBox.custom-control-input{
  height:1rem !important;
}
.WorkM_ApprovalApplicationListArea .explainArea {
  font-size: 1rem; 
  padding: 0.25rem; 
  background-color: rgb(238, 238, 238);
}
</style>